//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export let TranslationWidth;

(function (TranslationWidth) {
  TranslationWidth["SHORT"] = "short";
  TranslationWidth["LONG"] = "long";
})(TranslationWidth || (TranslationWidth = {}));